import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { IFechRequest } from "interfaces/fetch-duck";
import { requestErrorHandler } from "utils";
import { FetchTransitTimeArActions } from "store/ducks/settings/transit-time-ar";

export function* fetchTransitTimeArRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiGeneral.get, `/evonik-transit-times-ar/${id}`);

    yield put(FetchTransitTimeArActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchTransitTimeArActions.failure(errorMessage));
  }
}
